import { requester } from "App";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function PaymentGatewayPage() {
    const location = useLocation();
    const [isMounted, setMounted] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setMounted(true);
    }, [])

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const type = queryParams.get('type');
        const orderId = queryParams.get('orderId');
        const paymentKey = queryParams.get('paymentKey');
        const amount = queryParams.get('amount');
        const usedPoints = queryParams.get('usedPoints');
        const storeCode = queryParams.get('storeCode');
        if (isMounted) {
            if (type === "point") {
                
                let data = {
                    id: orderId,
                    price: amount
                }
                requester.pointRecharge(data, (result) => {
                    if (result.code === 0) {
                        // navigate("/ws/root/complete");
                    } else if (result.code === -1) {

                    }
                })
            } else if (type === "product") {
                let productData = {
                    id: orderId,
                    totalAmount: amount,
                    usedPoints: usedPoints
                }
                requester.changeOrderStatus(productData, (result) => {
                    
                    if (result.code === 0) {
                        window.location.replace(`/ws/${storeCode}/homepage/payment/complete`);
                    } else if (result.code === -1) {

                    }
                })
            } else {
                // navigate("/ws/root/fail")
            }
        }

    }, [isMounted]);
    return (
        <div>
            결제 처리 중...
        </div>
    );
}

export default PaymentGatewayPage;